var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { tabindex: "0" },
      on: {
        keydown: function($event) {
          return _vm.checkSlide($event)
        }
      }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "btn2 btn-next2",
            staticStyle: {
              "background-color": "transparent",
              border: "0px solid transparent"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.next.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "i",
              { staticClass: "fa fa-angle-right" },
              [
                _c("base-icon", {
                  staticClass: "ml-2",
                  attrs: {
                    width: "50",
                    height: "50",
                    src: "/static-appopensalud/img/icons/noun-arrow-blue.svg",
                    color: "blue"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn2 btn-prev2",
            staticStyle: {
              "background-color": "transparent",
              border: "0px solid transparent"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.prev.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "i",
              { staticClass: "fa fa-angle-right" },
              [
                _c("base-icon", {
                  staticClass: "ml-2",
                  attrs: {
                    width: "50",
                    height: "50",
                    src: "/static-appopensalud/img/icons/noun-arrow-blue.svg",
                    color: "blue"
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b5a59be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b5a59be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/carousel/Carousel.vue
// module id = 3754
// module chunks = 146